import { TotemDatePicker } from 'components/TotemDatePicker';
import { DetailList, DetailListRemoveButton } from 'components/DetailsView/DetailList';
import { dateFromString, formatDateAsAnniversary } from 'helpers/dateTimes';
import { SupplierClosingDatesRangeInput } from 'data/__generated__';

export const SupplierClosingDates = ({
    closingDatesRanges,
    setClosingDatesRanges,
}: {
    closingDatesRanges: SupplierClosingDatesRangeInput[];
    setClosingDatesRanges: (closingDatesRanges: SupplierClosingDatesRangeInput[]) => void;
}) => {
    function onClosingDateChange(date: Date, index: number) {
        setClosingDatesRanges(
            closingDatesRanges.map((closingDatesRange, closingDatesRangeIndex) => {
                if (closingDatesRangeIndex !== index) {
                    return closingDatesRange;
                }

                return {
                    ...closingDatesRange,
                    closingDate: formatDateAsAnniversary({ dateTime: date, useNewFormat: true }),
                };
            }),
        );
    }

    function onOpeningDateChange(date: Date, index: number) {
        setClosingDatesRanges(
            closingDatesRanges.map((closingDatesRange, closingDatesRangeIndex) => {
                if (closingDatesRangeIndex !== index) {
                    return closingDatesRange;
                }

                return {
                    ...closingDatesRange,
                    openingDate: formatDateAsAnniversary({ dateTime: date, useNewFormat: true }),
                };
            }),
        );
    }

    function removeRange(index: number) {
        setClosingDatesRanges(
            closingDatesRanges.filter((_, closingDatesRangeIndex) => closingDatesRangeIndex !== index),
        );
    }

    const errors = [] as string[];

    closingDatesRanges.forEach((closingDatesRange, index) => {
        const { closingDate, openingDate } = closingDatesRange;

        if (dateFromString(closingDate, true) >= dateFromString(openingDate, true)) {
            errors.push(`L'intervalle de fermeture n°${index + 1} a une date de réouverture avant celle de fermeture`);
        }
    });

    return (
        <>
            {errors.map((error, index) => (
                <div key={index} className="text-sm text-destructive">
                    {error}
                </div>
            ))}
            <DetailList
                label="Dates de fermeture"
                onAdd={() =>
                    setClosingDatesRanges([
                        ...closingDatesRanges,
                        {
                            closingDate: formatDateAsAnniversary({ dateTime: new Date(), useNewFormat: true }),
                            openingDate: formatDateAsAnniversary({ dateTime: new Date(), useNewFormat: true }),
                        },
                    ])
                }
                items={closingDatesRanges.map((closingDatesRange, index) => {
                    const { closingDate: closingDateDate, openingDate: openingDateDate } = closingDatesRange;

                    return (
                        <>
                            <TotemDatePicker
                                label="Fermeture"
                                selected={closingDateDate ? dateFromString(closingDateDate, true) : null}
                                onChange={(date) => {
                                    if (date) {
                                        onClosingDateChange(date, index);
                                    }
                                }}
                            />
                            <TotemDatePicker
                                label="Réouverture"
                                selected={openingDateDate ? dateFromString(openingDateDate, true) : null}
                                onChange={(date) => {
                                    if (date) {
                                        onOpeningDateChange(date, index);
                                    }
                                }}
                            />
                            <DetailListRemoveButton onClick={() => removeRange(index)} />
                        </>
                    );
                })}
            />
        </>
    );
};
